import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/app/programs/$programId/register')({
  beforeLoad: () => {
    throw redirect({ to: '/app/organizations/join' })
  },
})
